import {registerRoute as workbox_routing_registerRoute} from '/codebuild/output/src765/src/github.com/frickjack/little-elements/node_modules/workbox-routing/registerRoute.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/codebuild/output/src765/src/github.com/frickjack/little-elements/node_modules/workbox-strategies/CacheFirst.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});





workbox_routing_registerRoute(/\.(?:js|css|html|svg)$/, new workbox_strategies_CacheFirst({ "cacheName":"assets", plugins: [] }), 'GET');




